import React, { Component } from 'react';
import Banner from '../Common/Banner';
import {Modal} from 'react-bootstrap';
import call from "../Core/Services";

import Slider from 'react-slick';

import DocumentMeta from 'react-document-meta';

class CycleRent extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.state = {
			showModal: false,
			message : '',
			durationType: 'D',
		}		
	}

	submitForm = ( e ) => {
        
        e.preventDefault();

        let formData = {
            'name'      : this.refs.name.value,
            'email'     : this.refs.email.value,
            'phone'     : this.refs.phone.value,
            'comment'   : this.refs.comment.value,
            'category'  : 'RENTAL',

            'metaData'  : {
            	'duration'  	: this.refs.duration.value,
            	'durationType'	: this.state.durationType,
            	'people'  		: this.refs.peopleCount.value, 
            },

            
       };

        call.submitForm( formData, () => {
            
            this.refs.name.value    		 = '';
            this.refs.email.value       	 = '';
            this.refs.phone.value       	 = '';
            this.refs.comment.value     	 = '';
            this.refs.peopleCount.value     = '';
            this.refs.duration.value     = '';
    
            this.setState({
                message: 'Tak for din forespørgsel, vi svarer som regel i løbet af få timer'
            });

            setTimeout( () => {                
                this.setState({
                    message: ''
                });
            }, 10000)

        });


    }

    close = () => {
		this.setState({ showModal: false });
	}

	open = () => {
		this.setState({ showModal: true });
	}

	render() {
		
		const meta = {
			title: 			'Vi tilbyder den billigste og mest praktisk cykeludlejning i København',
			description: 	'I København er cykel en del af vores hverdag, hvis du gerne vil leve som en sand københavner kan du ikke undgå din cykel. Men hvad gør du når din cykel er til reparation eller mangler du bare en cykel for få dage?. Alaska cykler har den billigste løsning til denne udfordring.',
			canonical: 		window.location.href,
			meta: {
				charset: 	'utf-8',
				name: {
					keywords: 'cykeludlejning i københavn, billige cykler til leje, leje en cykel københavn'
				}
			}
	    };

		return (
			<div className="main-content" id="cycle-rent-page">
                
                <DocumentMeta {...meta} />

				<Banner 
					pageName='Cykeludlejning' 
					pageID='repair' 
					pageDesc='Oplev København på 2 hjul' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_scale,f_auto,h_800,q_auto/v1511687696/backgrounds/bike_rentals_2400x1350_sz.jpg' />

				<div className="scroll-stop"></div>

				<div className="container">					
                	<div className="row">
	                	<div className="col-md-8 col-md-offset-2 col-sm-12">
	            			<div className="description margin-top-60">
	            				<h3 className="sec-head text-center">Billige og overkommelige cykler</h3>
	            				<p >I København er cykel en del af vores hverdag, hvis du gerne vil leve som en sand københavner kan du ikke undgå din cykel. Men hvad gør du når din cykel er til reparation eller mangler du bare en cykel for få dage?</p>
	            				<p >Alaska cykler har den billigste løsning til denne udfordring.</p>
	            				<p >Vi tilbyder den billigste og mest praktisk cykeludlejning i København. Hos Alaska Cykler.har vi cykler til alle formål og budget.</p>
	            				<p >Bestilling kan ske over telefon så er du sikker på at din bestilling er klar når du kommer forbi i vores fysisk butik for at hente din lånecykel.</p>
	            				<p >Vi ønsker en detaljeret bestilling når du bestiller via e-mail</p>
	            				<p >om du/I har brug for hjelm, lys, cykeltasker osv. Afhentnings og afleverings tidspunkt og hvor mange cykler skal du/I låne.</p>
	            				<p >Det er bedst at bestille over telefonen så er du sikker på at din bestilling er klar når du kommer forbi i vores fysisk butik for at hente din lånecykel</p>

	            				<h3 className="sec-head text-center margin-top-40 margin-bottom-40">Priser</h3>
	                			<table className="table table-responsive table-bordered table-stripe">
								   <thead>
								      <tr>
								         <th width="33%">UDLEJNINGSPERIODE</th>
								         <th width="33%">STANDARD</th>
								         <th width="33%">HJELM</th>
								      </tr>
								   </thead>
								   <tbody>
								      <tr>
								         <td>6 hours</td>
								         <td>70 kr.</td>
									     <td>30 kr.</td>
								      </tr>
								      <tr>
								         <td>24 hours</td>
								         <td>100 kr.</td>
								         <td>30 kr.</td>
								      </tr>
								      <tr>
								         <td>Add Day</td>
								         <td>40 kr.</td>
								         <td>10 kr.</td>
								      </tr>
								      <tr>
								         <td>1 Week</td>
								         <td>375 kr.</td>
								         <td>90 kr.</td>
								      </tr>
								      <tr>
								         <td><span>Add Day</span></td>
								         <td>25 kr.</td>
								         <td>5 kr.</td>
								      </tr>
								      <tr>
								         <td>2 Weeks</td>
								         <td>540 kr.</td>
								         <td>115 kr.</td>
								      </tr>
								      <tr>
								         <td>3 Weeks</td>
								         <td>680 kr.</td>
								         <td>130 kr.</td>
								      </tr>
								      <tr>
								         <td>4 Weeks</td>
								         <td>800 kr.</td>
								         <td>145 kr.</td>
								      </tr>
								      <tr>
								         <td>2 Months</td>
								         <td>1190 kr.</td>
								         <td>240 kr.</td>
								      </tr>
								   </tbody>
								</table>

	                			<div className="text-center">
	                				<button type="button" className="btn btn-primary btn-lg" onClick={this.open} >Send Os Din Forespørgsel</button>
	                			</div>
	                		</div>
	            		</div>
            		</div>

            		<div className="featued-container margin-bottom-80">
                        <div className="row">
                            <div className="col-sm-6 col-sm-offset-6">
                                <div className="featured-wrapper has-overlay white-bg">
                                    <h2>Vi Tilbyder Forskellige Muligheder</h2>

                                    <ul className="steps">
                                    	<li>
                                    		<span className="icon">1</span>
                                    		Send os en e-mail <span className="label label-success" onClick={ this.open } >Send Forespørgsel</span>
                                    	</li>
                                    	<li>
                                    		<span className="icon">2</span>
                                    		Personlig betjening.
                                    	</li>
                                    	<li>
                                    		<span className="icon">3</span>
                                    		Kom til vores fysisk butik og  få rådgivning.
                                    	</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal show={this.state.showModal} onHide={this.close}>
						<Modal.Header closeButton>
							<Modal.Title>Forhør nu for flere detaljer</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<div className="row">
								<div className="col-md-12">
									
									<div className={ this.state.message ? 'alert alert-success show' : 'alert alert-success' }>
		                                <a className="close" onClick={ () => this.setState({message: '' }) } >&times;</a>
		                                { this.state.message }
		                            </div>

									<form role="form" id="rent-enquire-form" method="post" onSubmit={ this.submitForm } >
										
										<div className="row">
											<div className="form-group col-md-6">
												<label className="sr-only" htmlFor="first-name">Navn</label>
												<input type="text" required ref="name" name="first-name" placeholder="Navn" minLength={3} maxLength={15} className="form-control" />
											</div>
											<div className="form-group col-md-6">												
												<label className="sr-only" htmlFor="phone-number">Telefonnummer</label>
												<input type="number" required ref="phone" name="phone-number" placeholder="Telefonnummer" className="form-control" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-12">
												<label className="sr-only" htmlFor="email">Email Adresse</label>
												<input type="email" required ref="email" name="email" placeholder="Email adresse" minLength={3} maxLength={50} className="form-control" />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-md-6">
												<label className="sr-only" htmlFor="people-count">Antal Cykler</label>
												<input type="number" required ref="peopleCount" name="people-count" placeholder="Antal Cykler" minLength={1} maxLength={25} className="form-control" />
											</div>
											<div className="form-group col-md-6">												
												<label className="sr-only" htmlFor="duration">Udlejningsperiode </label>
												<input type="number" required ref="duration" name="duration" placeholder="Udlejningsperiode" className="form-control" />
												
												<div style={{position: 'absolute', right: '25px', top:'9px'}} >
													<div className="switch-field">
														<input type="radio" value="H" required name="duration-type" id="duration-type-h" ref="duration-type" />
														<label onClick={ () => this.setState({durationType: 'H'})} htmlFor="duration-type-h">Timer</label>
													
														<input type="radio" value="D" required name="duration-type" id="duration-type-d" ref="duration-type" />
														<label onClick={ () => this.setState({durationType: 'D'})} htmlFor="duration-type-d">Dage</label>
													</div>
												</div>
											</div>
										</div>

										<div className="row">
											<div className="form-group col-sm-12">
												<label className="sr-only">Forespørgselsdetaljer</label>
												<textarea required ref="comment" name="enquiry_details" className="form-control" minLength={10} maxLength={300} rows={5} placeholder="Indtast din forespørgsel her..." />
											</div>
										</div>

										<div className="row">
											<div className="form-group col-xs-4">
												<input type="submit" name="Submit" className="btn btn-primary btn-block" defaultValue="Indsend" />
											</div>
										</div>
																		
									</form>

								</div>
							</div>
						</Modal.Body>
					</Modal>

                </div>
				
			</div>
		);
	}
}

export default CycleRent;



// WEBPACK FOOTER //
// ./src/Pages/CycleRent.js